<script>
    import {fly} from 'svelte/transition';

    // Read dismiss flag at init — localStorage at top level is acceptable
    const dismissed = localStorage.getItem('pwa_install_dismissed') === '1';
    
    // Check if already installed (running as standalone PWA)
    // One-time synchronous read at module init — acceptable exception
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches
        || navigator.standalone === true;
    
    let deferredPrompt = null;
    let showBanner = false;

    // Capture the beforeinstallprompt event via <svelte:window>
    function handleBeforeInstallPrompt(event) {
        event.preventDefault();
        deferredPrompt = event;
        if (!dismissed && !isStandalone) {
            showBanner = true;
        }
    }

    async function handleInstall() {
        if (!deferredPrompt) return;
        showBanner = false;
        await deferredPrompt.prompt();
        deferredPrompt = null;
    }

    function handleDismiss() {
        showBanner = false;
        localStorage.setItem('pwa_install_dismissed', '1');
    }
</script>

<svelte:window
    on:beforeinstallprompt={handleBeforeInstallPrompt}
/>

{#if showBanner}
<div class="install-banner" transition:fly={{ y: 80, duration: 300 }}>
    <div class="banner-content">
        <div class="banner-left">
            <div class="banner-icon">🔧</div>
            <div class="banner-text">
                <div class="banner-title">Установить приложение?</div>
                <div class="banner-subtitle">Добавить на главный экран</div>
            </div>
        </div>
        <div class="banner-actions">
            <button type="button" class="btn-dismiss" on:click={handleDismiss}>
                Нет, спасибо
            </button>
            <button type="button" class="btn-install" on:click={handleInstall}>
                Да, установить
            </button>
        </div>
    </div>
</div>
{/if}

<style>
    .install-banner {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1000;
        background: #fff;
        box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.1);
        padding: 16px;
    }

    .banner-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        max-width: 100%;
    }

    .banner-left {
        display: flex;
        align-items: center;
        gap: 12px;
        flex: 1;
        min-width: 0;
    }

    .banner-icon {
        font-size: 32px;
        flex-shrink: 0;
    }

    .banner-text {
        flex: 1;
        min-width: 0;
    }

    .banner-title {
        font-size: 15px;
        font-weight: 500;
        color: #000;
        margin-bottom: 2px;
    }

    .banner-subtitle {
        font-size: 12px;
        color: #6b7280;
    }

    .banner-actions {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-shrink: 0;
    }

    .btn-dismiss {
        background: none;
        border: none;
        color: #6b7280;
        font-size: 14px;
        padding: 8px 12px;
        cursor: pointer;
        white-space: nowrap;
    }

    .btn-dismiss:hover {
        color: #374151;
    }

    .btn-install {
        background: #2563eb;
        color: #fff;
        border: none;
        border-radius: 8px;
        padding: 8px 16px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        white-space: nowrap;
        transition: background 0.2s ease;
    }

    .btn-install:hover {
        background: #1d4ed8;
    }

    @media (max-width: 390px) {
        .banner-content {
            flex-direction: column;
            align-items: stretch;
        }

        .banner-left {
            margin-bottom: 8px;
        }

        .banner-actions {
            width: 100%;
            justify-content: space-between;
        }

        .btn-dismiss,
        .btn-install {
            flex: 1;
        }
    }
</style>
